module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-box-image-sp-4bdf621c6fcebd13c1aaa44fa8f6fe41.jpg";